import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Button,
  Form,
  Input,
  notification,
  Col,
  Row,
  Select,
  Card,
  Tooltip,
  Collapse,
  Table,
} from "antd";

import { DeleteOutlined, SettingOutlined } from "@ant-design/icons";

import { getAuthuser } from "../../stored/mydata";
import dataOptionName from "./configMaster.json";

import apiGetMasterName from "../../api/masterName/getMaster";
import apiPostMasterName from "../../api/masterName/postMaster";
import apiUpdateMasterName from "../../api/masterName/updateMaster";
import apiDeleteMasterName from "../../api/masterName/deleteMaster";

import ModatDeleteMaster from "./modalDeleteMaster";
import ModalEditMaster from "./modalEditMaster";
import TableMaster from "./tableMaster";

export default function MasterName(prop) {
  const authUser = useSelector(getAuthuser);
  const [formData] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();

  const [data, setData] = useState([]);
  const [optionMaster, setOptionMaster] = useState({});
  const [master, setMaster] = useState("");

  const [isModalDelete, setIsModalDelete] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [masterEdit, setDeviceEdit] = useState({});
  const [masterDelete, setDeviceDelete] = useState({});
  const [showForm, setShowForm] = useState(false);

  const columnsData = [
    {
      title: "ID",
      dataIndex: "id",
      width: "6%",
      sorter: (a, b) => a.id - b.id,
      render: (_, record) => <div>{record.id}</div>,
    },
    {
      title: "ชื่อ",
      dataIndex: "name",
      width: "74%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record.name}>
          <div>{record.name}</div>
        </Tooltip>
      ),
    },
    {
      title: "แก้ไข",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              actionEditMaster(record);
            }}
          >
            <SettingOutlined />
          </div>
        </div>
      ),
    },
    {
      title: "ลบ",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (_, record) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            actionDeleteMaster(record);
          }}
        >
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  const getData = async (value) => {
    try {
      const masterPromise = new Promise((resolve, reject) => {
        apiGetMasterName(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [masterRes] = await Promise.all([masterPromise]);

      if (masterRes["data"]) {
        setData(masterRes["data"]);
        // console.log(masterRes["data"]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onChangeMaster = (value) => {
    formData.resetFields();
    setMaster(value);
    getData(value);
  };

  //Start Form Create
  const openForm = () => {
    formData.resetFields();
    setShowForm(!showForm);
  };

  const onFinish = (value) => {
    apiPostMasterName(authUser, master, value, (err, res) => {
      if (!err && res.statusCode === 201) {
        resetTable(master);
        setShowForm(false);
        formData.resetFields();
        api["success"]({
          message: "success",
          description: res.StatusCode,
        });
      } else {
        api["error"]({
          message: "error",
          description: res.StatusCode,
        });
      }
    });
  };
  //End Form Create

  // resetTable
  const resetTable = async (value) => {
    try {
      const masterPromise = new Promise((resolve, reject) => {
        apiGetMasterName(authUser, value, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res);
          }
        });
      });

      const [masterRes] = await Promise.all([masterPromise]);

      if (masterRes["data"]) {
        setData(masterRes["data"]);
        formData.resetFields();
      }
    } catch (error) {
      console.log(error);
    }
  };
  // resetTable

  // EditDevice
  const actionEditMaster = (value) => {
    setDeviceEdit(value);
    setIsModalEdit(true);
  };
  const actionEdit = (status, value) => {
    if (status) {
      resetTable(master);
      setIsModalEdit(false);

      api["success"]({
        message: "success",
        description: value,
      });
    } else {
      api["error"]({
        message: "error",
        description: "Error",
      });
    }
  };
  // EditDevice

  // DeleteDevice
  const actionDeleteMaster = (value) => {
    setDeviceDelete(value);
    setIsModalDelete(true);
  };
  const actionDelete = () => {
    apiDeleteMasterName(authUser, master, masterDelete["id"], (err, res) => {
      if (!err && res.message === "Deleted") {
        formData.resetFields();
        resetTable(master);
        setIsModalDelete(false);
        api["success"]({
          message: "success",
          description: res.Status,
        });
      } else {
        api["error"]({
          message: "error",
          description: "Error",
        });
      }
    });
  };
  // DeleteDevice

  useEffect(() => {
    setOptionMaster(dataOptionName);
  }, []);
  return (
    <div>
      {contextHolder}
      <Card>
        <Row>
          <Col span={12}>
            <div>
              <div>กรุณาเลือกประเภท</div>
              <div>
                <Select
                  showSearch
                  style={{
                    width: "100%",
                  }}
                  placeholder="Process"
                  size="large"
                  options={optionMaster}
                  onChange={(value, option) => {
                    onChangeMaster(value);
                  }}
                />
              </div>
            </div>
          </Col>
          <Col span={12}>
            <div style={styles.showData}>
              <div>Master Name : {master}</div>
            </div>
          </Col>
        </Row>
        <div
          style={{
            marginTop: "15px",
          }}
        >
          <Button onClick={openForm}>เพิ่ม Master</Button>
        </div>
        <Row>
          <Col span={12} style={{ margin: "20px 0 0 15px" }}>
            <div
              style={{
                marginTop: "15px",
              }}
            >
              {showForm && master !== "" ? (
                <>
                  <Form
                    form={formData}
                    onFinish={onFinish}
                    initialValues={{
                      name: "",
                    }}
                  >
                    <Form.Item
                      label="Name : "
                      name="name"
                      labelCol={{ flex: "100px" }}
                    >
                      <Input placeholder="name" size="large" />
                    </Form.Item>
                    <Button type="primary" htmlType="submit">
                      Submit
                    </Button>
                  </Form>
                </>
              ) : null}
            </div>
          </Col>
          <Col span={12} style={{ margin: "20px 0 0 15px" }}></Col>
        </Row>

        <Row
          style={{
            marginTop: "15px",
          }}
        >
          <Col span={24}>ชื่อเริ่มต้น</Col>
          {data.length ? (
            <>
              <TableMaster columns={columnsData} dataMaster={data} />
            </>
          ) : (
            <>ไม่มีอุปกรณ์</>
          )}
          <Col span={24}></Col>
        </Row>
      </Card>

      <ModatDeleteMaster
        closeModal={() => {
          setIsModalDelete(false);
        }}
        open={isModalDelete}
        submitModal={actionDelete}
        data={masterDelete}
      />

      <ModalEditMaster
        closeModal={() => {
          setIsModalEdit(false);
        }}
        submitModal={actionEdit}
        open={isModalEdit}
        dataMaster={masterEdit}
        master={master}
        authUser={authUser}
      />
    </div>
  );
}

const styles = {
  showData: {
    margin: "30px 10px 5px 20px",
    color: "#4F4F4F",
    fontSize: "14px",
    fontWeight: "300",
    lineHeight: "22px",
  },
};
